import { SHStack } from "@components/design-systems";
import { MSFilterSection } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/filter-section";
import { ModelScreenerFilterColumnDTO } from "@models/model-screener/entities/modelScreenerFilter";

type MSFilterColumnProps = {
  column?: ModelScreenerFilterColumnDTO;
  disabled?: boolean;
};

export const MSFilterColumn = ({ column, disabled }: MSFilterColumnProps) => {
  const renderSections = () => {
    if (!column || !column.sections || column.sections.length === 0)
      return null;

    return column.sections.map((section, index) => (
      <MSFilterSection key={index} section={section} disabled={disabled} />
    ));
  };

  return (
    <SHStack height={"100%"} width={"100%"} direction={"column"} gap={1.5}>
      {renderSections()}
    </SHStack>
  );
};
